<script setup lang="ts">
  const route = useRoute()
  const showLanguageSelector = computed(() => {
    return route.meta.showLanguageSelector !== false // Por defecto true
  })

  // Añadir clase al body cuando este layout está activo
  onMounted(() => {
    document.body.classList.add('simple-layout')
  })

  onUnmounted(() => {
    document.body.classList.remove('simple-layout')
  })
</script>

<template>
  <!-- <NuxtLoadingIndicator color="repeating-linear-gradient(to right,#ff620a 0%,#C40058 100%)" /> -->
  <CandyLoadingIndicator />
	<div class="flex flex-col justify-center items-center">
		<SimpleHeader :show-language-selector="showLanguageSelector" />
    <slot />
	</div>
</template>